import {
  IntegrationCategory,
  IntegrationConfig,
  IntegrationDomain,
  IntegrationStatus,
  IntegrationType,
} from '../types/integration';

export const integrationConfig: IntegrationConfig[] = [
  {
    name: 'SmartLead',
    domain: IntegrationDomain.SmartLeadAi,
    category: IntegrationCategory.LeadGeneration,
    type: IntegrationType.SMART_LEAD,
    description:
      'Connect Your SmartLead Account To Synchronize Your Cold Email Campaigns With Company And People Data.',
    icon: '/assets/images/Smartlead.jpg',
    status: IntegrationStatus.Available,
  },
  {
    name: 'Salesforce',
    domain: IntegrationDomain.SalesForceAi,
    category: IntegrationCategory.CRM,
    type: IntegrationType.SALES_FORCE,
    description: 'Integrate your CRM data with our platform.',
    icon: '/assets/images/SalesForce.jpg',
    status: IntegrationStatus.ComingSoon,
  },
  {
    name: 'HubSpot',
    domain: IntegrationDomain.HubSpotAi,
    category: IntegrationCategory.Marketing,
    type: IntegrationType.HUB_SPOT,
    description: 'Connect Your Marketing Automation Data.',
    icon: '/assets/images/Hupspot.jpg',
    status: IntegrationStatus.ComingSoon,
  },
];

export const SMART_LEAD_CAMPAIGN_ANALYTICS_URL = `https://app.smartlead.ai/app/email-campaign/:id/analytics`;
